import React, { useState } from "react";
import "./NavBarNew.css";
import mindyHello from "../../Images/logo.png";
import { FaSignInAlt } from "react-icons/fa";
import { Link } from "react-router-dom";
import axios from "axios";
import { useGoogleLogin } from "@react-oauth/google";
import { useNavigate, NavLink } from "react-router-dom";
import cross from "../../Images/cross.png";
import log from "../../../logger";

const NavbarNew = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isErrorOpen, setIsErrorOpen] = useState(false);
  const [error, setError] = useState("");
  const [user, setUser] = useState([]);
  const [role, setRole] = useState("");
  const navigate = useNavigate();
  let project;

  const login = useGoogleLogin({
    onSuccess: (codeResponse) => {
      fetch_email(codeResponse);
      setUser(codeResponse);
    },
    onError: (error) => {
      setError("Google Login failed. Please try again.");
      setIsErrorOpen(true);
    },
  });

  // const fetchUserRole = async () => {
  //   try {
  //     const response = await axios.get("/common/api/get_user_role/", {
  //       withCredentials: true,
  //     });
  //     setRole(response.data.role);
  //   } catch (error) {
  //     log.error(
  //       "Error fetching user role:",
  //       error.response?.data || error.message
  //     );
  //   }
  // };
  const fetch_email = async (user) => {
    if (!user) return;

    try {
      const authResponse = await axios.post("common/api/verify", {
        token: user.access_token,
      });

      if (authResponse.status === 200) {
        const project = authResponse.data.project;
        const userRole = authResponse.data.role;
        log.info("User Found in Mapping DB", {
          endpoint: "common/api/verify",
          method: "POST",
          project: project,
          response_status: 200,
          role: userRole,
        });

        if (!userRole) {
          log.error("User not Found in Mapping DB", {
            endpoint: "common/api/verify",
            method: "POST",
            project: project,
            response_status: 401,
            role: role,
          });
          throw new Error("Role is missing or invalid");
        }

        setRole(userRole);

        sessionStorage.setItem("project", project);
        // sessionStorage.setItem("role", userRole);

        authenticateAndFetchProfile(user, userRole);
      } else {
        throw new Error("Authentication failed");
      }
    } catch (error) {
      log.error("Error during authentication or profile fetch", {
        endpoint: "common/api/verify",
        method: "POST",
        project: project,
        response_status: 500,
        role: role,
      });
      setError("Authentication or profile fetch failed. Please try again.");
      setIsErrorOpen(true);
    }
  };

  let apiEndpoint;
  let userObject;
  let patient;
  const authenticateAndFetchProfile = async (user, userRole) => {
    const project = sessionStorage.getItem("project");

    try {
      apiEndpoint =
        userRole === "Physician" ||
          userRole === "MRI-Tech" ||
          userRole === "Nurse"
          ? "/operator/api/authenticate"
          : userRole === "Admin"
            ? "/admin/check_admin_auth"
            : userRole === "Patient"
              ? "/patient/api/authenticate"
              : null;

      if (!apiEndpoint) return;

      const authResponse = await axios.post(
        apiEndpoint,
        { token: user.access_token },
        { headers: { project } }
      );

      if (authResponse.status === 200) {
        const token = authResponse.data.access_token;
        if (
          userRole === "Physician" ||
          userRole === "MRI-Tech" ||
          userRole === "Nurse"
        ) {
          sessionStorage.setItem("operator_token", token);
        } else if (userRole === "Admin") {
          sessionStorage.setItem("admin_token", token);
        } else if (userRole === "Patient") {
          sessionStorage.setItem("patient_token", token);
        }

        // Set userObject based on the role

        if (userRole === "Admin") {
          userObject = authResponse.data.admin;
        } else if (
          userRole === "Physician" ||
          userRole === "MRI-Tech" ||
          userRole === "Nurse"
        ) {
          userObject = authResponse.data.operator;
        } else if (userRole === "Patient") {
          patient = authResponse.data.patient;
          userObject = authResponse.data.patient;
        }

        // Store userObject in session storage
        if (userObject) {
          // sessionStorage.setItem("userObject", JSON.stringify(userObject));

          if (userRole === "Patient") {
            log.info("User Fetched from DB", {
              endpoint: apiEndpoint,
              method: "POST",
              project: project,
              response_status: 200,
              role: role,
              user_id: userObject.patient_id,
            });
            navigate("/profile", { state: { patient } });
          } else {
            log.info("User Fetched from DB", {
              endpoint: apiEndpoint,
              method: "POST",
              project: project,
              response_status: 200,
              role: role,
              user_id: userObject.provider_id,
            });
            navigate(`/operatorPatientlist`, { state: { userObject } });
          }
        }
      } else {
        throw new Error("Authentication failed");
      }
    } catch (error) {
      log.error("Error while authenticating the user", {
        endpoint: apiEndpoint,
        method: "POST",
        project: project,
        response_status: 500,
        role: role,
      });

      setError("Error while authenticating the user. Please try again.");
      setIsErrorOpen(true);
    }
  };

  const handleErrorClose = () => {
    setIsErrorOpen(false);
  };

  // useEffect(() => {
  //     if (!isInitialLoad) {
  //         authenticateAndFetchProfile(user, navigate);
  //     }
  //     setIsInitialLoad(false);
  // }, [user, navigate]);

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  return (
    <>
      <nav className="navbar normal">
        <Link to="/">
          <div className="logo">
            <img src={mindyHello} alt="mindyhello" className="logo-image" />
          </div>
        </Link>

        <ul className={`navbar-links ${isOpen ? "show" : ""}`}>
          <li>
            <NavLink
              to="/physicians"
              className={({ isActive }) => (isActive ? "active-link" : "")}
            >
              Provider
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/patients"
              className={({ isActive }) => (isActive ? "active-link" : "")}
            >
              Patients
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/aboutus"
              className={({ isActive }) => (isActive ? "active-link" : "")}
            >
              About Us
            </NavLink>
          </li>
          <li>
            <button className="sign-in-button" onClick={() => login()}>
              <img
                src="https://developers.google.com/identity/images/g-logo.png"
                alt="Google Logo"
                className="google-logo"
              />
              Sign In <FaSignInAlt className="sign-in-icon" />
            </button>
          </li>
        </ul>

        {isErrorOpen && (
          <div className="error-modal-overlay">
            <div className="error-modal-content">
              <div className="error-modal-header">
                <img src={cross} alt="Error" className="cross-image" />
              </div>
              <h2>Oh Snap!</h2>
              <p>{error}</p>
              <button className="error-ok-button" onClick={handleErrorClose}>
                Ok
              </button>
            </div>
          </div>
        )}
      </nav>
      <nav className="navbar small">
        <Link to="/">
          <div className="logo">
            <img src={mindyHello} alt="mindyhello" className="logo-image" />
          </div>
        </Link>
        <button className="dropdown-toggle" onClick={toggleDropdown}>
          ☰ Menu
        </button>

        <ul className={`navbar-links ${isOpen ? "show" : ""}`}>
          <li>
            <NavLink
              to="/physicians"
              className={({ isActive }) => (isActive ? "active-link" : "")}
            >
              Provider
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/patients"
              className={({ isActive }) => (isActive ? "active-link" : "")}
            >
              Patients
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/aboutus"
              className={({ isActive }) => (isActive ? "active-link" : "")}
            >
              About Us
            </NavLink>
          </li>
          <li>
            <button className="sign-in-button" onClick={() => login()}>
              <img
                src="https://developers.google.com/identity/images/g-logo.png"
                alt="Google Logo"
                className="google-logo"
              />
              Sign In <FaSignInAlt className="sign-in-icon" />
            </button>
          </li>
        </ul>

        {isErrorOpen && (
          <div className="error-modal-overlay">
            <div className="error-modal-content">
              <div className="error-modal-header">
                <img src={cross} alt="Error" className="cross-image" />
              </div>
              <h2>Oh Snap!</h2>
              <p>{error}</p>
              <button className="error-ok-button" onClick={handleErrorClose}>
                Ok
              </button>
            </div>
          </div>
        )}
      </nav>
    </>
  );
};

export default NavbarNew;
